import type { Cell, Note } from "@fletchy/core";
import { Heart, Plus, Search } from "lucide-react";
import { formatDate } from "../utils/format";

interface NoteListProps {
  cells: Cell[];
  notes: Note[];
  query: string;
  selectedNoteId: string | null;
  title: string;
  onQueryChange(query: string): void;
  onCreateNote(): void;
  onSelectNote(noteId: string): void;
}

export function NoteList({
  cells,
  notes,
  query,
  selectedNoteId,
  title,
  onQueryChange,
  onCreateNote,
  onSelectNote,
}: NoteListProps) {
  return (
    <section className="noteList">
      <div className="searchBox">
        <Search size={16} />
        <input placeholder="Search notes, tags and cells" value={query} onChange={(event) => onQueryChange(event.target.value)} />
      </div>
      <div className="listHeader">
        <span>{title}</span>
        <button type="button" className="iconButton" aria-label="New note" onClick={onCreateNote}>
          <Plus size={17} />
        </button>
      </div>
      <div className="noteCards">
        {notes.map((note) => {
          const firstCell = cells.find((cell) => note.cellIds.includes(cell.id));
          return (
            <button
              type="button"
              key={note.id}
              className={note.id === selectedNoteId ? "noteCard active" : "noteCard"}
              onClick={() => onSelectNote(note.id)}
            >
              <span className="noteCardTitle">
                {note.favorite ? <Heart size={14} fill="currentColor" /> : null}
                {note.title}
              </span>
              <span className="noteCardExcerpt">{firstCell?.content.replace(/\s+/g, " ").slice(0, 120) || "Blank note"}</span>
              <span className="noteMeta">
                {formatDate(note.updatedAt)}
                {note.tags.length > 0 ? ` / ${note.tags.join(", ")}` : ""}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
